import React from "react";

// Pictograme de tip contur (linie), într-un singur stil; culoarea vine din `currentColor`.
const P = {
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  home: <path d="M3 11l9-8 9 8M5 10v10h5v-6h4v6h5V10" />,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" /></>,
  gearUser: <><circle cx="9" cy="8" r="3.6" /><path d="M2.5 20c0-3.6 2.9-6 6.5-6" /><circle cx="17.5" cy="16.5" r="2" /><path d="M17.5 12.5v1.2M17.5 19.3v1.2M13.5 16.5h1.2M20.3 16.5h1.2M14.7 13.7l.9.9M19.4 18.4l.9.9M20.3 13.7l-.9.9M15.6 18.4l-.9.9" /></>,
  building: <path d="M4 21V3h10v18M14 9h6v12M8 7h2M8 11h2M8 15h2M3 21h18" />,
  calendar: <path d="M4 6h16v15H4zM4 10h16M8 3v4M16 3v4" />,
  folder: <path d="M3 6h7l2 2h9v12H3z" />,
  clipboard: <path d="M8 4h8v3H8zM6 5H5v16h14V5h-1M9 12h6M9 16h6" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  shield: <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />,
  bell: <path d="M6 16v-5a6 6 0 1112 0v5l2 2H4zM10 21h4" />,
  check: <path d="M4 12l5 5L20 6" />,
  list: <path d="M9 6h11M9 12h11M9 18h11M4 6h1M4 12h1M4 18h1" />,
  chart: <path d="M4 20V11M10 20V5M16 20v-7M22 20H2M4 8l5-4 5 3 6-5" />,
  mail: <path d="M3 6h18v12H3zM3 7l9 7 9-7" />,
  key: <><circle cx="8" cy="14" r="4" /><path d="M11 11l9-8M16 8l3 3" /></>,
  dots: <><circle cx="12" cy="5" r="1.6" fill="currentColor" /><circle cx="12" cy="12" r="1.6" fill="currentColor" /><circle cx="12" cy="19" r="1.6" fill="currentColor" /></>,
  edit: <path d="M4 20h4L19 9l-4-4L4 16zM13 7l4 4" />,
  eye: <><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="M16 16l5 5" /></>,
  chevron: <path d="M9 6l6 6-6 6" />,
  logout: <path d="M10 4H4v16h6M15 8l4 4-4 4M19 12H9" />,
  phone: <path d="M7 2h10v20H7zM11 19h2" />,
  download: <path d="M12 4v11M7 11l5 5 5-5M4 20h16" />,
  density: <path d="M4 6h16M4 10h16M4 14h16M4 18h16" />,
};

export default function Icon({ name, size = 24, color, stroke = 1.8, style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color || "currentColor"} strokeWidth={stroke}
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: "none", ...style }}>{P[name] || P.list}</svg>
  );
}
